<template>
  <div :class="['product-fits', { 'product-fits--all-selected': isGreen }]">
    <div v-if="header" class="product-fits__header">
      {{ header }}
    </div>
    <div class="product-fits__container--outer">
      <div class="product-fits__container--inner">
        <oie-use-svg
          class="product-fits__icon"
          svg="circle-warning-outline"
          height="20"
          width="20"
          color="black"></oie-use-svg>
        <p class="product-fits__text">
          <span class="product-fits__text--bold">{{ tStatic('fractionExplanatoryTextShort') }}</span>
        </p>
      </div>
      <ul class="product-fits__list">
        <slot name="list"></slot>
      </ul>
      <p v-tooltip.top="tStatic('fractionExplanatoryTextLong')" class="product-fits__text product-fits__text--underlined">
        {{ tStatic('readMore') }}
      </p>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    isGreen: {
      type: Boolean,
      default: false
    },
    header: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.product-fits {
  border: 1px solid color(border-yellow);
  background-color: color(background-yellow);
  padding: measure(quarter);
  @include body-smaller;
}

.product-fits--all-selected {
  border-color: color(border-success-green);
  background-color: color(background-green-bar);
}

.product-fits__header {
  @include body-bold;
  margin-bottom: measure(quarter);
}

// LIST
.product-fits__container--outer {
  display: flex;
  align-items: flex-start;
}
// GRID
.grid--grid .product-fits__container--outer {
  flex-direction: column;
}

// LIST
.product-fits__container--outer >*:not(:last-child) {
  margin: 0 measure(quarter) 0 0;
}

// GRID
.grid--grid .product-fits__container--outer >*:not(:last-child) {
  margin: 0 0 measure(quarter) 0;
}

// LIST
.product-fits__container--inner {
  display: flex;
  align-items: center;
}

// GRID
.grid--grid .product-fits__container--inner {
  margin-bottom: measure(quarter);
}

.product-fits__icon {
  flex-shrink: 0;
  margin-right: measure(eighth);
}

.product-fits__text {
  white-space: nowrap;
  margin: 0;
}

.product-fits__text--bold {
  @include body-smaller-semi-bold;
}

.product-fits__text--underlined {
  text-decoration: underline;
}

// WHEN AND WHERE IS THIS APPLICABLE AND WHY?
.product-details__top--large-media .product-fits {
  order: 3;
  margin-top: measure(half);
  width: 100%;
}

// LIST
.product-fits__list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  flex-wrap: wrap;
}

// GRID
.grid--grid .product-fits__list {
  flex-direction: column;
}

.product-fits__list >*:not(:last-child) {
 margin-right: measure(eighth);
}

.product-fits__list .product-fits__list-item--is-selected {
  @include body-smaller-semi-bold;
}

.product-fits__list-item {
  display: flex;
  align-items: center;
}

.product-fits__list-item::before {
  content: '•';
  margin-right: measure(eighth);
}
</style>
